import React from "react";
import ReactDOM from "react-dom";
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import "./index.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";


const rootElement = document.getElementById("root");

const APP = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)


ReactDOM.render(APP, rootElement);
